











import { Component, Inject, Vue, Watch } from 'vue-property-decorator'
import HeaderMenu from './components/page/HeaderMenu.vue'
import { GetterAuth, MutationAuth, Payload } from '@/store/auth'
import { IAuth, UsernamePasswordCredentials } from 'auth-toolbox'
import Snackbar from '@/components/Snackbar.vue'
import { AxiosResponseExt } from '@/api/resources'
import AccessService from '@/services/access'
// import { VuetifyBreakpoint } from 'vuetify/types/services/breakpoint'
import { MutationNavigation } from '@/store/navigation'
import AppDialog from './components/system/Dialog.vue'
import { MutationSnackbar, SnackbarEntry } from '@/store/snackbar'
import { ProductItem } from '@/store/product'
import { GetterCart, MutationCart } from '@/store/cart'
import ProductModel from '@/api/model/product'
import ProductResource from '@/api/resources/product'

@Component({
  components: {
    HeaderMenu,
    Snackbar,
    AppDialog
  }
})
export default class App extends Vue {
  @Inject()
  productResource: ProductResource
  products: ProductModel[] = []

  async mounted () {
    if (!sessionStorage.getItem('productAll')) {
      this.products = await this.productResource.products()
      // console.log(this.products)
      sessionStorage.setItem('productAll', JSON.stringify(this.products))
      console.log('Rechargement des products dans le sessionStorage !')
    }
  }
}
